"use strict";
/**
 * import alert from './alerts.js'
 *
 * Usage
 *
 * new alert().session()
 * // This is for laravel messages, call it in app.js
 *
 * new alert().response()
 * // This is for js messages.
 * // Params
 * // type = 'error' or 'success'
 * // response = string or Array
 *
 * new alert().custom()
 * // This is for js messages.
 * // Params
 * // type = 'error' or 'success'
 * // response = object eg. { title: string, content: string or Array }
 *
 * new alert().confirm()
 * // This is for html messages, , call it in app.js

 * // Example <a>
 * <a
 * alert="confirm-link"
 * alert-title="Lorem"
 * alert-content="Lorem ipsum dolor"
 * alert-continue="Continue"
 * alert-cancel="Cancel"
 * ></a>

 * // Example <form>
 * <button type="submit"
 * alert="confirm-form"
 * alert-title="Lorem"
 * alert-content="Lorem ipsum dolor"
 * alert-continue="Continue"
 * alert-cancel="Cancel"
 * ></button>
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertConfirm = exports.AlertCustom = exports.AlertResponse = exports.AlertSession = void 0;
// require('jquery-confirm')
var sweetalert2_min_1 = require("sweetalert2/dist/sweetalert2.min");
var __ = {
    en: {
        cancel: "Cancel",
        close: "Close",
        continue: "Continue",
        title: {
            success: "Completed",
            error: "Something is wrong",
        },
    },
    es: {
        cancel: "Cancelar",
        close: "Cerrar",
        continue: "Continuar",
        title: {
            success: "Completado",
            error: "Hay un problema",
        },
    },
};
var settings = {
    showConfirmButton: false,
    showCloseButton: true,
};
var errorAlert = function (response) {
    var content = response.constructor === Array
        ? "<ul><li>".concat(response.join("</li><li>"), "</li></ul>")
        : response;
    var options = {
        icon: "error",
        title: __[window.app.locale].title.error,
        html: content,
    };
    options = window._.extend(options, settings);
    sweetalert2_min_1.default.fire(options);
};
var successAlert = function (message) {
    var content = message.constructor === Array
        ? "<ul><li>".concat(message.join("</li><li>"), "</li></ul>")
        : "<p>".concat(message, "</p>");
    var options = {
        icon: "success",
        title: __[window.app.locale].title.success,
        html: content,
    };
    options = window._.extend(options, settings);
    sweetalert2_min_1.default.fire(options);
};
var customAlert = function (type, response) {
    var content = response.content.constructor === Array
        ? "<ul><li>".concat(response.content.join("</li><li>"), "</li></ul>")
        : response.content;
    var options = {
        icon: type,
        html: content,
        title: response.title,
    };
    options = window._.extend(options, settings);
    sweetalert2_min_1.default.fire(options);
};
var confirmAlert = function ($alert) {
    var swalAppBtns = sweetalert2_min_1.default.mixin({
        customClass: {
            confirmButton: "btn btn--primary x:mrg-lr-5",
            cancelButton: "btn btn--secondary x:mrg-lr-5",
        },
        buttonsStyling: false,
    });
    var action = function () {
        if ($alert.getAttribute("alert") === "confirm-form") {
            $alert.closest("form").submit();
        }
        else {
            window.location.href = $alert.getAttribute("href");
        }
    };
    // if ($alert.getAttribute("alert") === "confirm-link") {
    //   const action = () => {
    //     window.location.href = $alert.getAttribute("href");
    //   };
    // }
    var options = {
        title: $alert.getAttribute("alert-title") || "",
        html: $alert.getAttribute("alert-content") || "",
        showCloseButton: true,
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "<div>".concat($alert.getAttribute("alert-continue") || __[window.app.locale].continue, "</div>"),
        cancelButtonText: "<div>".concat($alert.getAttribute("alert-cancel") || __[window.app.locale].cancel, "</div>"),
    };
    swalAppBtns.fire(options).then(function (result) {
        if (result.isConfirmed) {
            action();
        }
    });
};
// class alert {
var constructor = function () { return document.querySelectorAll("[alert]"); };
var AlertSession = function () {
    if (window.app.errors.length > 0)
        errorAlert(window.app.errors);
    if (window.app.success.length > 0)
        successAlert(window.app.success);
};
exports.AlertSession = AlertSession;
var AlertResponse = function (type, response) {
    if (type === void 0) { type = null; }
    if (response === void 0) { response = null; }
    if (type === "error")
        errorAlert(response);
    if (type === "success")
        successAlert(response);
};
exports.AlertResponse = AlertResponse;
var AlertCustom = function (type, response) {
    if (type === void 0) { type = null; }
    if (response === void 0) { response = {}; }
    if (Object.keys(response).length === 0)
        return false;
    customAlert(type, response);
};
exports.AlertCustom = AlertCustom;
var AlertConfirm = function () {
    var alerts = constructor();
    if (alerts.length > 0)
        return false;
    alerts.forEach(function ($alert) {
        $alert.addEventListener("click", function (e) {
            e.preventDefault();
            confirmAlert(e.currentTarget);
        });
    });
};
exports.AlertConfirm = AlertConfirm;
